import { IndexStructure } from 'components/modules/public/blogs/ArticleWrapper';

import Component from './component';

export interface Props extends ParentProps { }

export interface ParentProps {
    indexStructure: IndexStructure;
}

Component.defaultProps = {};
export default Component;
